<div class="ConfirmModal">
    <mat-toolbar color="warn">
        <h3>{{ "confirmDelete" | translate }} </h3>
    </mat-toolbar>
        <mat-dialog-content>
            <h5 fxLayout="row" fxLayoutAlign="center center" class="text-center" class="mt-15">{{ "confirm.message" | translate }}</h5>
            <form [formGroup]="form" autocomplete="off">
                <div [ngSwitch]="data.key">
                    <!-- message: `You're about to delete ${category.name}. Deleting this ${this.type} will remove this ${this.type} from all products.`, -->

                    <div *ngSwitchCase="'sorter'">
                        <strong><p>{{ "confirm.pt1" | translate }} <span [innerHTML]="data.item"></span>. {{ "confirm.pt2" | translate }} {{ data.type | translate }} {{ "confirm.pt3" | translate }} {{ data.type | translate }} {{ "confirm.pt4" | translate }}</p></strong>
                    </div>
                    <div *ngSwitchDefault>
                        <strong *ngIf="scopeMode === 'single' && !data.deleteScopeChoice"><p>{{ "confirm." + data.key | translate }}</p></strong>
                        <strong *ngIf="scopeMode === 'account'"><p>{{ "confirm.deleteProduct.deleteFromAccountHint" | translate }}</p></strong>
                    </div>
                </div>

                <!-- What is being deleted, so the user can check it is the right one. -->
                <p *ngIf="data.itemName" class="ConfirmModal__item"><strong>{{ data.itemName | sanitizeString }}</strong></p>

                <div *ngIf="scopeMode === 'choice'" class="text-left mt-15">
                    <p style="margin-bottom: 4px;"><strong>{{ "confirm.deleteProduct.removeFromLocation" | translate }}</strong></p>
                    <p style="margin-bottom: 20px;">{{ "confirm.deleteProduct.removeFromLocationHint" | translate }}</p>
                    <p style="margin-bottom: 4px;"><strong>{{ "confirm.deleteProduct.deleteFromAccount" | translate }}</strong></p>
                    <p style="margin-bottom: 0;">{{ "confirm.deleteProduct.deleteFromAccountHint" | translate }}</p>
                </div>

                <br />
                <mat-form-field appearance="outline">
                    <input matInput autocomplete="off"  id="ConfirmModal__input" placeholder="{{ 'delete_capital_EN' | translate }}" required #input class="form-control" formControlName="delete" (keyup)="onCheckInputEvent($event)">
                </mat-form-field>

                <div *ngIf="data.reason != null && data.reason" class="text-left mt-15">
                    <span>{{"pickings.table.delete.reason" | translate}}</span>
                    <mat-form-field appearance="outline" class="mt-0">
                        <input matInput autocomplete="off" placeholder="{{ 'reason' | translate }}" formControlName="reason" [required]="!!data.reasonRequired">
                    </mat-form-field>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-dialog-close mat-button color="secondary">{{ "cancel" | translate }}</button>
            <ng-container *ngIf="scopeMode === 'choice'; else singleDelete">
                <button [mat-dialog-close]="'location'" mat-button color="warn" [disabled]="!canConfirm">{{ "confirm.deleteProduct.removeFromLocation" | translate }}</button>
                <button [mat-dialog-close]="'system'" mat-button color="warn" [disabled]="!canConfirm">{{ "confirm.deleteProduct.deleteFromAccount" | translate }}</button>
            </ng-container>
            <ng-template #singleDelete>
                <button id="ConfirmModal__submitButton" [mat-dialog-close]="scopeMode === 'account' ? 'system' : 'true'" mat-button color="warn" cdkFocusInitial [disabled]="!canConfirm">{{ "delete" | translate }}</button>
            </ng-template>
        </mat-dialog-actions>
  </div>